import { render } from "./FirmaRapportino.vue?vue&type=template&id=297a8956&scoped=true&ts=true"
import script from "./FirmaRapportino.vue?vue&type=script&lang=ts"
export * from "./FirmaRapportino.vue?vue&type=script&lang=ts"

import "./FirmaRapportino.vue?vue&type=style&index=0&id=297a8956&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297a8956"]])

export default __exports__